import React, { useState, useReducer, useEffect, useContext } from "react";
import { Modal, ModalBody } from "reactstrap";
import { CusButton } from "../../Components/From/Button";
import { Global } from "../../App";
import { FormattedMessage } from "react-intl";



function Tool_needStaffCheck({
  allData,
  setIsNeedStaffCheckModel,
  needStaffCheckID,
  setneedStaffCheckID,
  isSentOrder,
  sentOrder,
  onClose,
  updateAddOrderExtra,
  
}) {
  const [oldAns, setOldAns] = useState(0);
  const handleClick = async(option) => {    
    setneedStaffCheckID(option.id);
    if (globalState.ordermode === "addorder") {
        updateAddOrderExtra(option.id)       
    } 
  };
  const { globalState, dispatchGlobal } = useContext(Global);

  const isSelect = (id)=>{
    if(!globalState.selectedExtra || !globalState.selectedExtra.selectedExtraA){
      return false;
    }
    return globalState.selectedExtra.selectedExtraA.some(x=>x.qusetionId === globalState.selectedExtra.selectedExtraQ.id && x.ansId === id);
  }

  const isDisable = () =>{
    if(!globalState.selectedExtra || !globalState.selectedExtra.selectedExtraA){
      return false;
    }
    return globalState.selectedExtra.selectedExtraA.some(x=>x.qusetionId === globalState.selectedExtra.selectedExtraQ.id);
  }

  useEffect(()=>{
    if(globalState.selectedExtra.selectedExtraA){    
      let old = globalState.selectedExtra.selectedExtraA.filter(x=>x.qusetionId === globalState.selectedExtra.selectedExtraQ.id)[0];
      if(old){  
        setOldAns(old.ansId);
      }
    }    
  },[])

  return (
    <Modal isOpen fade={false} backdrop={false} onClose={onClose}>
      <div className="Tool Tool__CusSp d-flex justify-content-center align-items-center">
        <div className="Tool__CusSp__content d-flex flex-column h-75 justify-content-between p-5 position-relative min-h-400">
          <div className="d-flex flex-column position-absolute fixed-top p-4  my-2 h-100">
            <div className="Tool__CusSp__title">
              {globalState.selectedExtra.selectedExtraQ ? globalState.selectedExtra.selectedExtraQ.langName : ""}
            </div>       
            <hr className="" />
            <div className="h-100 modal-scroll">
              <div className="w-100 d-flex flex-wrap justify-content-between">
                {globalState.selectedExtra.selectedExtraQ.extraOptionList.length > 0
                  ? globalState.selectedExtra.selectedExtraQ.extraOptionList.map((option, index) => (
                      <a
                        key={index}
                        className={`need_button ${
                          isSelect(option.id) ? "need_button-on" : ""
                        } w-45`}
                        onClick={() => {handleClick(option)}}
                      >
                        {option.langName}
                      </a>
                    ))
                  : ""}
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between m-0 p-4 position-absolute fixed-bottom bg-white">
            <div className="col-6 w-50 p-1">
              <CusButton.White
                children={<FormattedMessage id="popup.buttonBack" />}
                className="btn-block py-2"
                onClick={
                  () => {
                    setneedStaffCheckID(oldAns)                  
                    setIsNeedStaffCheckModel(false);
                  }
                  // onClose
                }
              />
            </div>
            <div className="col-6  w-50 p-1">
              <CusButton.Red
                disabled={!isDisable()}
                children={<FormattedMessage id="popup.buttonConfirm" />}
                className="btn-block py-2"
                onClick={
                  () => {
                    console.log("click confirm needStaffCheck");
                    if(!globalState.selectedExtra){
                      console.log("globalState.selectedExtra 不存在");
                    }
                    if(isSentOrder==true){
                      if(allData.filter(x=>x.selected === 1).length !== globalState.selectedExtra.selectedExtraA.length){
                        let first = allData.filter(x=>x.selected === 1 && !globalState.selectedExtra.selectedExtraA.some(y=>y.qusetionId === x.id))[0];
                        dispatchGlobal({
                          type: "UPDATE",
                          payload: [
                            {
                              key: "selectedExtra",
                              val: {
                                ...globalState.selectedExtra,
                                selectedExtraQ:first
                              },
                            },
                          ],
                        });
                        setIsNeedStaffCheckModel(false);
                        setTimeout(function(){
                          console.log("wait 0.5 second");
                        }, 500);
                        setIsNeedStaffCheckModel(true);
                      }
                      else{
                        if (globalState.ordermode === "addorder") {}
                        setIsNeedStaffCheckModel(false);
                        sentOrder();
                      }
                    }else{
                        setIsNeedStaffCheckModel(false);
                    }
                  }
                  // onClose
                }
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default Tool_needStaffCheck;
